let state = {
    Cards : [
        {
            subtitle: "CX True Wireless",
            text1: `Sennheiser CX True Wireless - позволяет наслаждаться превосходным кристально чистым звуком, длительным временем автономной работы и простотой в использовании. Фирменный звук Sennheiser гарантируют 7-миллиметровыми динамические преобразователи, а отличную пассивную шумоизоляцию - эргономичный дизайн.`,
            text2: `Беспроводные наушники обеспечивают 9 часов воспроизведения и 18 часов автономной работы с использованием зарядного футляра. Управление вызовами и голосовым помощником осуществляется с помощью интуитивно понятных сенсорных панелей, а функция Bass Boost (усиление низких частот) и встроенный эквалайзер позволяют настроить звук по своему вкусу.`,
            src: "/img/card5.png",
            id: "1",
            video: "https://youtu.be/dbGq5odYHlQ",
            alt: "Sennheiser CX True Wireless",
            href: "https://www.pult.ru/product/naushniki-sennheiser-cx-true-wireless-white",
            posibilities: [ 
                {   
                    icon:"/img/ear.svg",
                    text:"Пассивная шумоизоляция"
                },
                {   
                    icon:"/img/sensor.svg",
                    text:"Настраиваемое сенсорное управление"
                },
                {   
                    icon:"/img/drop.svg",
                    text:"Влагозащита по стандарту IPX4"
                },
                {   
                    icon:"/img/converter.svg",
                    text:"Малоинерционный преобразователь"
                },
                {   
                    icon:"/img/autonomy.svg",
                    text:"27 часов автономной работы"
                },
            ],
            sliderWhite: [
                {src: "/img/pictureslider11.png"},
                {src: "/img/pictureslider12.png"},
                {src: "/img/pictureslider13.png"},
                {src: "/img/pictureslider14.png"}
            ],
            sliderBlack: [
                {src: "/img/pictureslider15.png"},
                {src: "/img/pictureslider16.png"},
                {src: "/img/pictureslider17.png"},
                {src: "/img/pictureslider18.png"}
            ]
        },
        {
            subtitle: "CX Plus True Wireless",
            text1: `Sennheiser CX Plus True Wireless - позволяет наслаждаться превосходным кристально чистым звуком, длительным временем автономной работы и простотой в использовании. Фирменный звук Sennheiser гарантируют 7-миллиметровыми динамические преобразователи, а отличную пассивную шумоизоляцию - эргономичный дизайн. Наслаждайтесь музыкой дома, на работе или в дороге с помощью специального преобразователя True Response для воспроизведения идеального звучания.`,
            text2: `Беспроводные наушники обеспечивают 8 часов воспроизведения и 16 часов автономной работы с использованием зарядного футляра. Управление вызовами и голосовым помощником осуществляется с помощью интуитивно понятных сенсорных панелей, а функция Bass Boost (усиление низких частот) и встроенный эквалайзер позволяют настроить звук по своему вкусу.`,
            src: "/img/card5.png",
            id: "2",
            video: "https://www.youtube.com/watch?v=rs32_qPepWk",
            alt: "Sennheiser CX Plus True Wireless",
            href: "https://www.pult.ru/product/naushniki-sennheiser-cx-plus-true-wireless-black",
            posibilities: [ 
                {   
                    icon:"/img/noisesuppression.svg",
                    text:"Активное шумоподавление"
                },
                {   
                    icon:"/img/transparency.svg",
                    text:"функция акустической прозрачности"
                },
                {   
                    icon:"/img/sensor.svg",
                    text:"Настраиваемое сенсорное управление"
                },
                {   
                    icon:"/img/drop.svg",
                    text:"Влагозащита по стандарту IPX4"
                },
                {   
                    icon:"/img/converter.svg",
                    text:"Малоинерционный преобразователь"
                },
                {   
                    icon:"/img/autonomy2.svg",
                    text:"24 часов автономной работы"
                },
            ],
            sliderWhite: [
                {src: "/img/pictureslider21.png"},
                {src: "/img/pictureslider22.png"},
                {src: "/img/pictureslider23.png"},
                {src: "/img/pictureslider24.png"}
            ],
            sliderBlack: [
                {src: "/img/pictureslider25.png"},
                {src: "/img/pictureslider26.png"},
                {src: "/img/pictureslider27.png"},
                {src: "/img/pictureslider28.png"},
                
            ]
        }
    ],
    Subtitle : [
        {text: `Компромиссы в отношении качества звука? Ни за что! Ставьте звук на первое место, как это делает Sennheiser.`},
        {text: `Купите себе лучшие в своем классе наушники, которые превратят прослушивание музыки в удовольствие.`}
    ],
    Sliders : [
        [
            {src:"/img/slider11.png"},
            {src:"/img/slider12.png"},
            {src:"/img/slider13.png"},
            {src:"/img/slider14.png"}
        ],
        [
            {src:"/img/slider21.png"},
            {src:"/img/slider22.png"},
            {src:"/img/slider23.png"},
            {src:"/img/slider24.png"}
        ]
    ]
}
export default state;